<breadcrumb></breadcrumb>
<div class="content-box">
  <div class="row">
    <div class="col-md-12">
      <div class="element-wrapper">
        <h6 class="element-header">
          {{ 'HotelReservations.Title' | translate }}
        </h6>
        <div class="element-box">
          <div class="row">
            <div class="col-md-3" *ngIf="creds && creds.role === 'admin'">
              <div class="form-group">
                <label for="" style="visibility: hidden;"> Date wise filter</label>
                <ng-select
                  [items]="dateBasedFilterOptions"
                  bindLabel="label"
                  bindValue="value"
                  placeholder=""
                  [(ngModel)]="dateBasedFilter"
                >
                </ng-select>
              </div>
            </div>

            <ng-template [ngIf]="dateBasedFilter == 'stay'">
              <div class="col-md-3">
                <section>
                  <div class="form-group">
                    <label for=""> {{ 'HotelReservations.StayDate' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend" (click)="dateFromPicker.open()">
                        <div class="input-group-text">
                          <i class="fas fa-calendar-alt"></i>
                        </div>
                      </div>
                      <mat-datepicker #dateFromPicker (closed)="dateFromInput.blur()"></mat-datepicker>
                      <input
                        class="form-control"
                        #dateFromInput
                        placeholder=""
                        [(ngModel)]="stayDate"
                        type="text"
                        name="date"
                        [matDatepicker]="dateFromPicker"
                        (focus)="dateFromPicker.open()"
                      />
                    </div>
                  </div>
                </section>
              </div>
            </ng-template>

            <ng-template [ngIf]="dateBasedFilter == 'arrival'">
              <div class="col-md-3">
                <section>
                  <div class="form-group">
                    <label for=""> {{ 'HotelReservations.DateFrom' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend" (click)="dateFromPicker.open()">
                        <div class="input-group-text">
                          <i class="fas fa-calendar-alt"></i>
                        </div>
                      </div>
                      <mat-datepicker #dateFromPicker (closed)="dateFromInput.blur()"></mat-datepicker>
                      <input
                        class="form-control"
                        #dateFromInput
                        placeholder=""
                        [(ngModel)]="dates.from"
                        type="text"
                        name="date"
                        [matDatepicker]="dateFromPicker"
                        (focus)="dateFromPicker.open()"
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div class="col-md-3">
                <section>
                  <div class="form-group">
                    <label for=""> {{ 'HotelReservations.DateFrom' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend" (click)="dateToPicker.open()">
                        <div class="input-group-text">
                          <i class="fas fa-calendar-alt"></i>
                        </div>
                      </div>
                      <mat-datepicker #dateToPicker (closed)="dateToInput.blur()"></mat-datepicker>
                      <input
                        class="form-control"
                        #dateToInput
                        placeholder=""
                        [(ngModel)]="dates.to"
                        type="text"
                        name="date"
                        [matDatepicker]="dateToPicker"
                        (focus)="dateToPicker.open()"
                        (ngModelChange)="validateDateRange()"
                      />
                    </div>
                  </div>
                </section>
              </div>
            </ng-template>

            <!-- Single Button (when only one integration exists) -->
            <div class="col-md-3" *ngIf="!multipleIntegration && pmsIntegrations && pmsIntegrations.length">
              <div class="form-group">
                <label for="" style="visibility: hidden;">Integration button</label>
                <button
                  class="btn btn-primary btn-block res-hotel-btn"
                  [disabled]="loadingHotelRes"
                  (click)="triggerLoading(0)"
                >
                  <span *ngIf="loadingHotelRes; else singleIntegrationLabel">
                    <span class="loader-res"></span>
                  </span>
                  <ng-template #singleIntegrationLabel>
                    {{ 'HotelReservations.FetchHotelReservations' | translate }}
                  </ng-template>
                </button>
              </div>
            </div>

            <!-- ng-select Dropdown (when multiple integrations exist) -->
            <ng-template [ngIf]="multipleIntegration">
              <div class="col-md-3 form-group">
                <label for="" style="visibility: hidden;">Integration button</label>

                <!-- Dropdown to select integration -->
                <ng-select
                  [items]="pmsIntegrations"
                  bindLabel="label"
                  placeholder="{{ 'HotelReservations.SelectHotelIntegrations' | translate }}"
                  (change)="onSelectIntegration($event)"
                >
                </ng-select>
              </div>

              <div class="col-md-3 form-group">
                <label for="" style="visibility: hidden;">Integration button</label>

                <!-- Button to trigger selected integration -->
                <button
                  class="btn btn-primary btn-block res-hotel-btn"
                  [disabled]="!selectedIntegration || loadingHotelRes"
                  (click)="triggerLoading(pmsIntegrations.indexOf(selectedIntegration))"
                >
                  <span *ngIf="loadingHotelRes; else buttonLabel">
                    <span class="loader-res"></span>
                  </span>
                  <ng-template #buttonLabel>
                    {{ 'HotelReservations.FetchHotelReservations' | translate }}
                  </ng-template>
                </button>
              </div>
            </ng-template>
          </div>

          <div class="row">
            <div class="col-md-12">
              <section>
                <div class="form-group actions">
                  <label for="">{{ 'HotelReservations.PredefinedPeriods' | translate }}</label
                  ><br />
                  <button class="btn btn-light" (click)="setDates('today')">
                    {{ 'HotelReservations.Today' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('tomorrow')">
                    {{ 'HotelReservations.Tomorrow' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('thisWeek')">
                    {{ 'HotelReservations.CurrentWeek' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('nextWeek')">
                    {{ 'HotelReservations.NextWeek' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('next2Weeks')">
                    {{ 'HotelReservations.Next2Weeks' | translate }}
                  </button>
                  <!-- <button class="btn btn-light" (click)="setDates('nextMonth')">
                    {{ 'HotelReservations.NextMonth' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('next2Months')">
                    {{ 'HotelReservations.Next2Months' | translate }}
                  </button>
                  <button class="btn btn-light" (click)="setDates('next6Months')">
                    {{ 'HotelReservations.Next6Months' | translate }}
                  </button> -->
                </div>
              </section>
            </div>
          </div>
        </div>

        <div class="element-box">
          <div class="row">
            <div class="col-md-4">
              <div class="element-wrapper">
                <div
                  class="element-box hotel-res-list"
                  [ngStyle]="{
                    'min-height': paginatedReservations?.length ? 'auto' : '30vh',
                    'overflow-y': paginatedReservations?.length ? 'auto' : 'visible'
                  }"
                >
                  <!-- Top: Total Count -->
                  <div class="top-bar">
                    <div class="total-count">
                      {{ 'HotelReservations.TotalReservation' | translate }}: {{ hotelReservations.length }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <div class="input-group">
                          <input
                            class="form-control"
                            placeholder="{{ 'HotelReservations.Search' | translate }}"
                            [(ngModel)]="searchTerm"
                            type="text"
                          />
                          <div class="input-group-append">
                            <div class="input-group-text btn-primary search-btn" (click)="updatePagination()">
                              <i class="fas fa-search"></i>
                            </div>
                            &nbsp;
                            <div
                              class="input-group-text btn-primary search-btn"
                              *ngIf="searchTerm"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-times"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <ng-select
                          [items]="flattenedMealOptions"
                          bindLabel="label"
                          bindValue="value"
                          [(ngModel)]="searchMealPlan"
                          (ngModelChange)="updatePagination()"
                          placeholder="{{ 'HotelReservations.Filter' | translate }}"
                          [searchable]="false"
                          [clearable]="true"
                        >
                          <ng-template ng-option-tmp let-item="item">
                            <div [ngStyle]="{ 'font-weight': item.type === 'group' ? 'bold' : 'normal' }">
                              {{ item.label }}
                            </div>
                          </ng-template>

                          <ng-template ng-footer-tmp>
                            <div class="d-flex align-items-center p-2 border-top">
                              <input
                                type="checkbox"
                                id="newReservationsOnly"
                                [(ngModel)]="showOnlyNewReservations"
                                (change)="updatePagination()"
                                style="margin-right: 6px"
                              />
                              <label for="newReservationsOnly" style="margin: 0; font-size: 0.9em">
                                {{ 'HotelReservations.NewReservations' | translate }}
                              </label>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <!-- Pagination Controls -->
                  <div class="pagination-controls" *ngIf="totalPages > 1">
                    <button class="btn btn-primary" (click)="prevPage()" [disabled]="currentPage === 1">
                      <<< {{ 'HotelReservations.Previous' | translate }}
                    </button>
                    <span>{{
                      'HotelReservations.PageStatus' | translate: { current: currentPage, total: totalPages }
                    }}</span>
                    <button class="btn btn-primary" (click)="nextPage()" [disabled]="currentPage === totalPages">
                      {{ 'HotelReservations.Next' | translate }} >>>
                    </button>
                  </div>

                  <!-- Reservation Card -->
                  <div class="card-grid">
                    <div class="card" *ngFor="let row of paginatedReservations">
                      <div class="card-header">
                        <div class="date-box">
                          {{ row.arrivalDate | amDateFormat: 'DD.MM.YYYY' }} →
                          {{ row.departureDate | amDateFormat: 'DD.MM.YYYY' }}
                          <div
                            *ngIf="row.attachedReservations && row.attachedReservations.length > 0"
                            class="card-actions btn btn-primary"
                            (click)="showAttachedReservations(row)"
                          >
                            <i class="fa-solid fa-people-group"></i>
                          </div>
                          <div
                            class="card-actions"
                            (click)="placeGuest(row)"
                            [ngClass]="!row.hotelId ? 'btn btn-primary' : 'btn btn-update-res'"
                          >
                            <i class="fas fa-table"></i>
                          </div>
                          <div class="card-actions btn btn-primary" (click)="row.expanded = !row.expanded">
                            <i class="fas fa-plus"></i>
                          </div>
                        </div>

                        <div class="guest-info">
                          <span *ngIf="row.board">
                            <span class="badge" [ngStyle]="{ background: fetchColor(row.board) }">{{ row.board }}</span
                            >&nbsp;
                          </span>

                          <span *ngIf="row.type">
                            <span *ngIf="row.type" [ngStyle]="{ background: 'lightgray' }" class="badge">{{
                              row.type
                            }}</span
                            >&nbsp;
                          </span>

                          <span class="guest-name">
                            {{ row.guestInfo?.name }} {{ row.guestInfo?.firstName }}
                            <ng-template [ngIf]="row?.displayName"> ({{ row?.displayName }})</ng-template>
                            ({{ row.guestCount }})
                          </span>
                        </div>
                      </div>

                      <!-- Expandable Section -->
                      <div class="card-details" *ngIf="row.expanded">
                        <p>
                          <strong>{{ 'HotelReservations.ReservationNumber' | translate }}:</strong>
                          {{ row.reservationNo }}
                        </p>
                        <p>
                          <strong>{{ 'HotelReservations.Room' | translate }}:</strong> {{ row.roomNo }}
                        </p>
                        <p *ngIf="row.notes">
                          <strong>{{ 'HotelReservations.Notes' | translate }}:</strong> {{ row.notes }}
                        </p>
                        <p *ngIf="row.guestInfo?.guestNotes">
                          <strong> {{ 'HotelReservations.GuestNotes' | translate }}:</strong>
                          {{ row.guestInfo?.guestNotes }}
                        </p>
                        <p *ngIf="row.guestInfo?.email">
                          <strong>{{ 'HotelReservations.Email' | translate }}:</strong> {{ row.guestInfo?.email }}
                        </p>
                        <p *ngIf="row.guestInfo?.phone">
                          <strong>{{ 'HotelReservations.PhoneNumber' | translate }}</strong>
                          {{ row.guestInfo?.phone }}
                        </p>

                        <div *ngIf="row.reservationInfo">
                          <div *ngFor="let item of row.reservationInfo | keyvalue">
                            <ng-template [ngIf]="item.value">
                              <strong>{{ item.key }}:</strong>
                              <span [class.preline]="item.value?.length > 20">
                                {{ item.value }}
                              </span>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="mt-5" [formGroup]="reservationFormGroup">
                <div class="container">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for=""> {{ 'HotelReservations.Arrival' | translate }}</label>
                        <div class="input-group">
                          <div class="input-group-prepend" (click)="arrivalDatePicker.open()">
                            <div class="input-group-text">
                              <i class="fas fa-calendar-alt"></i>
                            </div>
                          </div>
                          <mat-datepicker #arrivalDatePicker (closed)="dateFromInput1.blur()"></mat-datepicker>
                          <input
                            class="form-control"
                            #dateFromInput1
                            formControlName="arrivalDate"
                            placeholder="{{ 'HotelReservations.SelectDate' | translate }}"
                            type="text"
                            name="arrivalDate"
                            [min]="minArrivalDate"
                            [matDatepicker]="arrivalDatePicker"
                            (focus)="arrivalDatePicker.open()"
                            (dateChange)="checkIsSelectedTimeIntervalValid()"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for=""> {{ 'HotelReservations.Departure' | translate }}</label>
                        <div class="input-group">
                          <div class="input-group-prepend" (click)="departureDatePicker.open()">
                            <div class="input-group-text">
                              <i class="fas fa-calendar-alt"></i>
                            </div>
                          </div>
                          <mat-datepicker #departureDatePicker (closed)="dateFromInput2.blur()"></mat-datepicker>
                          <input
                            class="form-control"
                            #dateFromInput2
                            formControlName="departureDate"
                            placeholder="{{ 'HotelReservations.SelectDate' | translate }}"
                            type="text"
                            [min]="minDepartureDate"
                            name="departureDate"
                            [matDatepicker]="departureDatePicker"
                            (focus)="departureDatePicker.open()"
                            (dateChange)="checkIsSelectedTimeIntervalValid()"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label for=""> {{ 'HotelReservations.ReservationNumber' | translate }}</label>
                      <input
                        class="form-control"
                        formControlName="reservationNumber"
                        type="text"
                        autocomplete="nope"
                        placeholder="{{ 'HotelReservations.ReservationNumber' | translate }}"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for=""> {{ 'HotelReservations.Name' | translate }}</label>
                      <input
                        class="form-control"
                        formControlName="name"
                        type="text"
                        autocomplete="nope"
                        placeholder=" {{ 'HotelReservations.EnterName' | translate }}"
                      />
                    </div>

                    <div class="form-group col-md-4">
                      <label for=""> {{ 'HotelReservations.FirstName' | translate }}</label>
                      <input
                        class="form-control"
                        formControlName="firstName"
                        type="text"
                        autocomplete="nope"
                        placeholder="{{ 'HotelReservations.EnterFirstName' | translate }}"
                      />
                    </div>

                    <div class="form-group col-md-4">
                      <label for=""> {{ 'HotelReservations.RoomNumber' | translate }}</label>
                      <input
                        class="form-control"
                        formControlName="roomNumber"
                        type="text"
                        autocomplete="nope"
                        placeholder="{{ 'HotelReservations.RoomNumber' | translate }}"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.MealPlan' | translate }}</label>
                        <ng-select
                          [items]="mealOptions"
                          bindLabel="label"
                          bindValue="value"
                          placeholder="{{ 'HotelReservations.SelectMealPlan' | translate }}"
                          formControlName="board"
                          (change)="changeBoardOption()"
                          [ngClass]="{ 'border-danger': callPlaced && !reservationFormGroup.value.board }"
                        >
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.StayDuration' | translate }}</label>
                        <ng-select
                          [searchable]="false"
                          [clearable]="false"
                          formControlName="stayTime"
                          placeholder="{{ 'HotelReservations.StayDuration' | translate }}"
                        >
                          <ng-option *ngFor="let st of stayTimes" [value]="st">{{ st?.name }}</ng-option>
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <div class="form-group">
                          <label for="">{{ 'HotelReservations.Tags' | translate }}</label>
                          <ng-select
                            [items]="tags"
                            [addTag]="false"
                            [hideSelected]="true"
                            multiple="true"
                            bindLabel="label"
                            formControlName="selectedTags"
                            placeholder="{{ 'HotelReservations.SelectTags' | translate }}"
                          >
                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              <span class="ng-value-label">
                                <i class="fas fa-circle" [style.color]="item.color"></i> {{ item.label }}
                              </span>
                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                              <i class="fas fa-circle" [style.color]="item.color"></i> {{ item.label }}
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.NumPersons' | translate }}</label>
                        <ng-select
                          [searchable]="false"
                          (change)="onNumberOfPersonsChange()"
                          [clearable]="false"
                          formControlName="numberOfPersons"
                          required
                        >
                          <ng-option *ngFor="let person of createNumValues(20); let i = index" value="{{ i + 1 }}">
                            {{ i + 1 }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.NumChildren' | translate }}</label>
                        <ng-select [searchable]="false" [clearable]="false" formControlName="numberOfKids" required>
                          <ng-option *ngFor="let person of createNumValues(21); let i = index" value="{{ i }}">{{
                            i
                          }}</ng-option>
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.NumHighChairs' | translate }}</label>
                        <ng-select
                          [searchable]="false"
                          [clearable]="false"
                          formControlName="numberOfHighChairs"
                          required
                        >
                          <ng-option *ngFor="let person of createNumValues(21); let i = index" value="{{ i }}">
                            {{ i }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <label class="mb-0">{{ 'HotelReservations.Intolerances' | translate }}</label>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            (click)="showDietaryPanel = !showDietaryPanel"
                          >
                            <i class="fas" [ngClass]="showDietaryPanel ? 'fa-minus' : 'fa-plus'"></i>
                          </button>
                        </div>
                        <div
                          *ngIf="showDietaryPanel"
                          style="border: 1px solid #dee2e6; border-radius: 8px; padding: 16px; background: #fff;"
                        >
                          <div *ngFor="let group of incompatibilitiesGrouped" class="mb-3">
                            <div
                              class="text-muted font-weight-bold mb-2"
                              style="font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase;"
                            >
                              {{ 'HotelReservations.DietaryType.' + group.key | translate }}
                            </div>
                            <div class="d-flex flex-wrap" style="gap: 6px;">
                              <span
                                *ngFor="let code of group.value"
                                (click)="toggleHotelCode(code)"
                                style="display:inline-block; cursor:pointer; border-radius:20px; padding:5px 14px; font-size:13px; margin:2px; user-select:none; transition: all 0.15s;"
                                [style.background]="isHotelCodeSelected(code) ? '#4a9fd5' : '#fff'"
                                [style.color]="isHotelCodeSelected(code) ? '#fff' : '#333'"
                                [style.border]="isHotelCodeSelected(code) ? '1px solid #4a9fd5' : '1px solid #ccc'"
                                >{{ 'HotelReservations.DietaryCode.' + code | translate }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label for=""> {{ 'HotelReservations.GroupTags' | translate }}</label>
                      <input
                        class="form-control"
                        formControlName="groupTags"
                        type="text"
                        placeholder="{{ 'HotelReservations.GroupTags' | translate }}"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.Packages' | translate }}</label>
                        <textarea class="form-control text-area-section" rows="4" formControlName="packages"></textarea>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.GuestNotes' | translate }}</label>
                        <textarea
                          class="form-control text-area-section"
                          rows="4"
                          formControlName="guestNotes"
                          disabled="true"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="">{{ 'HotelReservations.FreeFieldNotes' | translate }}</label>
                        <textarea
                          class="form-control text-area-section"
                          rows="4"
                          formControlName="notes"
                          placeholder="{{ 'HotelReservations.EnterNotes' | translate }}"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row float-right">
                    <button class="btn btn-primary btn-lg" *ngIf="updateReservation" (click)="updateOnlyHotelInfo()">
                      {{ 'Common.Submit' | translate }}
                    </button>
                  </div>

                  <br class="clear" />

                  <div class="row res-data-form" *ngIf="reservationForm.controls.length > 0">
                    <div class="col-md-12 table-responsive">
                      <table class="table table-striped">
                        <ng-container
                          formArrayName="reservations"
                          *ngFor="let reservation of reservationForm.controls; let i = index"
                        >
                          <thead *ngIf="reservation.value.resIndex == 1">
                            <tr>
                              <th scope="col" colspan="7"></th>
                            </tr>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">{{ 'HotelReservations.Date' | translate }}</th>
                              <th scope="col">{{ 'HotelReservations.Meal' | translate }}</th>
                              <th scope="col">{{ 'HotelReservations.Area' | translate }}</th>
                              <th scope="col">{{ 'HotelReservations.Time' | translate }}</th>
                              <th scope="col">{{ 'HotelReservations.Table' | translate }}</th>
                            </tr>
                          </thead>

                          <tbody class="form-group">
                            <ng-container [formGroupName]="i">
                              <tr
                                [ngClass]="{
                                  'is-first-meal-row': reservation.value.resIndex == 1,
                                  'is-error-row': reservation.value.errorMessage
                                }"
                                *ngIf="reservation.value.resIndex"
                              >
                                <td style="width:6%;cursor:pointer" (click)="onRowIndexClick(i)">
                                  {{ reservation.value.resIndex }}
                                  <i
                                    class="fas"
                                    [ngClass]="rowExpandedState[i] ? 'fa-chevron-down' : 'fa-chevron-right'"
                                    style="margin-left:5px;"
                                  ></i>
                                </td>

                                <td style="width: 10%;">
                                  <input
                                    class="form-control"
                                    disabled
                                    value="{{ reservation.value.date | date }}"
                                    type="text"
                                    autocomplete="nope"
                                    style="width: 120px;"
                                  />
                                </td>
                                <td style="width: 10%;">
                                  {{ mealTypeMap[reservation.value?.mealType] || reservation.value?.mealType }}
                                </td>
                                <td class="form-group" style="width: 20%;">
                                  <ng-select
                                    [searchable]="reservation.value.isEditable"
                                    [clearable]="reservation.value.isEditable"
                                    (change)="searchFreeTables(i)"
                                    formControlName="restaurant"
                                    [items]="reservation.value.listOfRestaurants"
                                    bindLabel="name"
                                    bindValue="id"
                                    placeholder="Restaurant auswählen"
                                    [placeholder]="
                                      reservation.value.isEditable
                                        ? ('HotelReservations.SelectRestaurant' | translate)
                                        : ''
                                    "
                                    [disabled]="!reservation.value.isEditable"
                                    [ngClass]="{ 'label-like': !reservation.value.isEditable }"
                                  >
                                  </ng-select>
                                </td>
                                <td class="form-group" style="width: 5%;">
                                  <ng-select
                                    [searchable]="reservation.value.isEditable"
                                    [clearable]="reservation.value.isEditable"
                                    formControlName="time"
                                    [placeholder]="
                                      reservation.value.isEditable ? ('HotelReservations.SelectTime' | translate) : ''
                                    "
                                    [disabled]="!reservation.value.isEditable"
                                    [ngClass]="{ 'label-like': !reservation.value.isEditable }"
                                    (change)="searchFreeTables(i)"
                                    bindLabel="time"
                                    bindValue="time"
                                    [items]="reservation.value.listOfTimes"
                                  >
                                    <ng-template class="option-select" ng-label-tmp let-item="item">
                                      <div>{{ item.time }}</div>
                                    </ng-template>
                                    <ng-template
                                      class="option-select"
                                      ng-option-tmp
                                      let-item="item"
                                      let-index="index"
                                      let-search="searchTerm"
                                    >
                                      <div>{{ item.time }}</div>
                                      <div class="text-danger" *ngIf="item.isClosed" style="font-style:italic">
                                        {{ 'HotelReservations.Closed' | translate }}
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </td>
                                <td class="form-group" style="width: 20%;">
                                  <ng-select
                                    [items]="reservation.value.listOfTables"
                                    [searchable]="reservation.value.isEditable"
                                    [clearable]="reservation.value.isEditable"
                                    formControlName="table"
                                    [placeholder]="
                                      reservation.value.isEditable ? ('HotelReservations.SelectTable' | translate) : ''
                                    "
                                    [disabled]="!reservation.value.isEditable"
                                    [ngClass]="{ 'label-like': !reservation.value.isEditable }"
                                    [loading]="reservation.value.tableLoader"
                                    bindLabel="table.name"
                                    bindValue="table.id"
                                    (change)="onTableChanged(i)"
                                    multiple="true"
                                    class="table-select"
                                  >
                                    <ng-template ng-label-tmp let-item="item">
                                      Table {{ item.table.name }}
                                    </ng-template>

                                    <ng-template ng-option-tmp let-item="item" let-index="i">
                                      <div
                                        class="option-wrapper"
                                        [ngClass]="{ 'not-available-item': item.isNotAvailable }"
                                      >
                                        Table {{ item.table.name }}
                                        <span style="float:right">
                                          <i class="fas fa-user"></i> {{ item.table.seats }}
                                        </span>
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </td>
                                <td>
                                  <button (click)="editReservation(i)" class="btn btn-light">
                                    <i class="fas fa-edit"></i>
                                  </button>
                                  <button
                                    [ngClass]="{
                                      'btn-light': !reservation.value.time,
                                      'btn-primary': reservation.value.time
                                    }"
                                    [disabled]="!reservation.value.time"
                                    (click)="callCopyAllItems(i, reservation.value.mealType)"
                                    class="btn"
                                    title="Kopieren"
                                  >
                                    <i class="far fa-copy"></i>
                                  </button>
                                  <button
                                    class="btn btn-danger"
                                    (click)="removeReservationAtIndex(i)"
                                    matTooltip="Löschen"
                                  >
                                    <i class="far fa-trash-alt"></i>
                                  </button>
                                  <button
                                    *ngIf="reservation.value.errorMessage && reservation.value.table"
                                    (click)="replaceGuestReservation(i)"
                                    class="btn btn-light"
                                  >
                                    <i class="fas fa-exchange-alt"></i>
                                  </button>
                                </td>
                              </tr>
                              <tr *ngIf="rowExpandedState[i] && reservation.value.resIndex">
                                <td colspan="7" class="accordion-cell acc-open">
                                  <div class="p-2">
                                    <div class="row">
                                      <div class="col-md-5">
                                        <div class="form-group">
                                          <label>{{ 'HotelReservations.StayDuration' | translate }}</label>
                                          <ng-select
                                            [searchable]="false"
                                            [clearable]="true"
                                            bindLabel="name"
                                            bindValue="value"
                                            formControlName="reservationStayTime"
                                            [placeholder]="'HotelReservations.StayDuration' | translate"
                                          >
                                            <ng-option *ngFor="let st of stayTimes" [value]="st">{{
                                              st?.name
                                            }}</ng-option>
                                          </ng-select>
                                        </div>
                                      </div>
                                      <div class="col-md-5">
                                        <div class="form-group">
                                          <label>{{ 'HotelReservations.Tags' | translate }}</label>
                                          <ng-select
                                            [items]="tags"
                                            bindLabel="label"
                                            bindValue="id"
                                            multiple="true"
                                            formControlName="reservationTags"
                                            [addTag]="false"
                                            [hideSelected]="true"
                                            placeholder="{{ 'HotelReservations.SelectTags' | translate }}"
                                          >
                                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                              <span class="ng-value-label">
                                                <i class="fas fa-circle" [style.color]="item?.color || '#999'"></i>
                                                {{ item?.label || item }}
                                              </span>
                                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
                                                >x</span
                                              >
                                            </ng-template>
                                            <ng-template ng-option-tmp let-item="item">
                                              <i class="fas fa-circle" [style.color]="item?.color || '#999'"></i>
                                              {{ item?.label || item }}
                                            </ng-template>
                                          </ng-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                            <tr class="table-is-not-free-error" *ngIf="reservation.value.errorMessage">
                              <td class="error-tr-td"></td>
                              <td class="error-tr-td"></td>
                              <td class="error-tr-td"></td>
                              <td colspan="3" class="error-tr-td">{{ reservation.value.errorMessage }}</td>
                            </tr>
                          </tbody>
                        </ng-container>
                      </table>
                      <ng-container *ngxPermissionsOnly="['admin', 'addReservation']">
                        <button
                          class="btn btn-primary btn-lg btn-block save-button"
                          (click)="createReservation()"
                          [promiseBtn]="submitObservable"
                          [disabled]="isSubmitting"
                        >
                          {{
                            updateReservation
                              ? ('HotelReservations.UpdateReservation' | translate)
                              : ('HotelReservations.CreateReservation' | translate)
                          }}
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
